// Exposes node require
export default eval('typeof require !== \'undefined\' && require'); // eslint-disable-line no-eval



// WEBPACK FOOTER //
// ./src/runtime/electron/require.js